export interface SiteConfig {
  fixedTitle?: string
  adminEnabled: boolean
  showVisitorNotice: boolean
}

export const DEFAULT_SITE_TITLE = "ODing's personal belongings"
export const defaultSite: SiteConfig = { adminEnabled: true, showVisitorNotice: false }
export const saleDinNorthSite: SiteConfig = {
  fixedTitle: "din's pre-loved items",
  adminEnabled: false,
  showVisitorNotice: true,
}

export const VISITOR_NOTICE = 'This site uses a cookie to recognise your browser—no account is needed. If you switch devices or browsers, or clear cookies, you’ll be treated as a new visitor and will need to send your interest again. Your earlier submission will still be saved.'

export function initialSiteTitle(config: SiteConfig): string {
  return config.fixedTitle ?? DEFAULT_SITE_TITLE
}

export async function resolveSiteTitle(config: SiteConfig, load: () => Promise<{ title: string }>): Promise<string> {
  if (config.fixedTitle !== undefined) return config.fixedTitle
  try { return (await load()).title }
  catch { return DEFAULT_SITE_TITLE }
}
